import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Details,
  Loader,
} from './styles';

const TesterInfo = (props) => {
  const { tester, loading } = props;

  if (loading || !tester) {
    return (
      <Loader inline size="tiny" data-loader="tester-info-loader" />
    );
  }

  const { user } = tester || {};
  const { profile } = user || {};
  const {
    firstName, gender, birthdate, linkedinFields,
  } = profile || {};

  const age = (value) => (`${moment().diff(value, 'years')} years`);

  const testerInfo = [];

  if (!_.isEmpty(gender) && !_.isEmpty(birthdate)) {
    testerInfo.push(gender);
    testerInfo.push(age(birthdate));
  }

  if (linkedinFields && linkedinFields.currentPosition) {
    testerInfo.push(linkedinFields.currentPosition.title);
  }

  return (
    <Details>
      {firstName}
      {testerInfo.length > 0 ? ' - ' : ''}
      {testerInfo.join(', ')}
    </Details>
  );
};

TesterInfo.defaultProps = {
  tester: {},
};

TesterInfo.propTypes = {
  tester: PropTypes.shape({
    user: PropTypes.shape({
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        gender: PropTypes.string,
        birthdate: PropTypes.string,
        linkedinFields: PropTypes.shape({
          currentPosition: PropTypes.shape({
            title: PropTypes.string,
          }),
        }),
      }),
    }),
  }),
  loading: PropTypes.bool.isRequired,
};

export default TesterInfo;
